<div class="container">
  <div class="tile-icon">
    <img class="" src="../../../assets/icons/hondaLink.png" alt="HondaLink" />
  </div>

  <div class="status-icon">
    <img src="../../../assets/success_new.png" alt="Success" />
    <!-- <img src="../../../assets/error.svg" alt="Error"> -->
  </div>

  <p class="font-14 black-color text-center-align">
    Your PIN has been successfully reset
  </p>

  <div class="action-btn-container flex justify-content-center">
    <button mat-flat-button class="edit-form-button standard-btn primar-btn btn-width" [routerLink]="['/myvehicle']"
      (click)="onMyAccount()">
      MyAccount
    </button>
  </div>
</div>